import React from 'react';
import ReactDOM from 'react-dom/client';
import './config/firebase-config';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraBaseProvider } from '@chakra-ui/react';
import { RefreshProvider } from './utils/context/refreshContext';
import { JobListRefreshProvider } from './utils/context/JobListRefresh';

// Import Redux Provider and store
import { Provider } from 'react-redux';
import store from './store/store'; // Make sure the path is correct

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
  <JobListRefreshProvider>
  <RefreshProvider>
  <ChakraBaseProvider>
    <App />
  </ChakraBaseProvider>
  </RefreshProvider>
  </JobListRefreshProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
